import { store } from './state-store.js';
import { analyzeDiagnostics } from '../validation/diagnostics.js';

export function buildSessionReport() {
  const session = store.getSessionData();
  const diagnostics = analyzeDiagnostics(session);

  return {
    reportVersion: '1.1.0',
    generatedAt: new Date().toISOString(),
    ...session,
    diagnostics,
  };
}
